import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EntitiesPipe, ProductToLowercasePipe } from '@uc/utilities';
import { UniversityEvent } from '@uc/web/shared/data-models';
import { BookEventBtnComponent } from '@uc/web/shared/leads';

@Component({
	selector: 'uc-open-days-recommended-events-wrapper',
	templateUrl: './open-days-recommended-events-wrapper.component.html',
	imports: [
		DatePipe,
		RouterLink,
		EntitiesPipe,
		BookEventBtnComponent,
		ProductToLowercasePipe,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpenDaysRecommendedEventsWrapperComponent {
	events = input.required<UniversityEvent[]>();
	componentName = input.required<string>();
	uniName = input.required<string>();
	uniId = input.required<number>();
	uniSlug = input.required<string>();
	ugSearchOrderPosition = input.required<number | null>();
	privacyPolicyUrl = input.required<string | null>();
}
